// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useState, useMemo } from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import ActivityMobileSwitchField from '../ActivityMobileSwitchField';
import Checkboxes from '../../../utils/FormWidgets/Checkboxes';

const StyledWrapper = styled.div`
  position: relative;

  &&& {
    .checkbox {
      margin-right: 10px;
      margin-bottom: 20px;

      input {
        width: 20px;
        height: 20px;
      }
    }
  }
`;

const StyledModeSwitcher = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  font-size: 14px;

  .react-switch-bg {
    &&& {
      width: 20px;
      height: 15px;
    }
  }
`;

const ActivityFormMultiSelectMobile = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  label,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  selectedItems,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  options,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onItemClick,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  isEditMode,
}) => {
  const [showSelectedOnly, setShowSelectedOnly] = useState(false);

  const optionsToShow = useMemo(
    () => {
      if (showSelectedOnly) return selectedItems;
      return options;
    }, // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    [showSelectedOnly, selectedItems.length]
  );

  return (
    <StyledWrapper>
      <h4 className='header'>{label}</h4>
      <StyledModeSwitcher>
        <ActivityMobileSwitchField
          label='Show Selected'
          name='showSelected'
          onChange={() => setShowSelectedOnly(!showSelectedOnly)}
          checked={showSelectedOnly}
          isEditMode
        />
      </StyledModeSwitcher>
      {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        <Checkboxes
          onChange={event => onItemClick(event.target.value)}
          options={optionsToShow.map(option => ({
            value: option,
            label: option,
          }))}
          values={selectedItems}
          disabled={!isEditMode}
          styles={{ display: 'block' }}
        />
      }
    </StyledWrapper>
  );
};

export default ActivityFormMultiSelectMobile;
